const INACTIVE_SUBSCRIPTION_MESSAGE = 'Subscription is inactive. Update billing to continue writing changes.';

export const SUBSCRIPTION_LOCKOUT_RECOVERY_MESSAGE =
  'Changes are read-only while billing access is reviewed. Review Billing settings or use Settings > Data to export data before making more changes.';

type ErrorLike = {
  message?: unknown;
  data?: unknown;
  shape?: { data?: unknown };
};

function hasSubscriptionWriteLockedFlag(data: unknown): boolean {
  return (
    typeof data === 'object' &&
    data !== null &&
    'subscriptionWriteLocked' in data &&
    (data as { subscriptionWriteLocked?: unknown }).subscriptionWriteLocked === true
  );
}

function getErrorMessage(error: unknown): string | null {
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null) {
    const message = (error as ErrorLike).message;
    return typeof message === 'string' ? message : null;
  }
  return null;
}

export function isSubscriptionWriteLockError(error: unknown): boolean {
  if (typeof error === 'object' && error !== null) {
    const errorLike = error as ErrorLike;
    if (
      hasSubscriptionWriteLockedFlag(errorLike.data) ||
      hasSubscriptionWriteLockedFlag(errorLike.shape?.data)
    ) {
      return true;
    }
  }

  return getErrorMessage(error) === INACTIVE_SUBSCRIPTION_MESSAGE;
}
